<template>
    <div class="container">
        <div id='div-gpt-ad-1682322729799-0'></div>
        <div style= "min-height:500px;max-height:500px" v-loading="loadingDepartmentData">
        <!-- 头像 组别名称|账户角色 切换账户 -->
        <div class="home_head">
            <div class="ch-form-img">
                <el-image :src="userImg" :lazy="lazyLoadingAva" :key="userImg" fit="fill" class="ch-image" v-if="userImg"></el-image>
            </div>
            <div class="ch-form-tit">
                <span style="font-size: 24px; font-weight: 700">{{ userInfo.departmentName }} | {{ userInfo.roleName }}</span>
                <span v-if="userInfo.roleList && userInfo.roleList.length > 1" style="font-size: 18px; color: blue; margin-left: 20px; cursor: pointer" @click="changeDepartment">切換賬戶</span>
            </div>
            <div class="home_date">
                <span v-if="truePerson" style="font-size: 20px; padding-top: 10px; color: #ffffff">個人用量總覽-{{ new Date(mondata).getFullYear() }}年{{ new Date(mondata).getMonth() + 1 }}月</span>
                <span v-if="!truePerson" style="font-size: 20px; padding-top: 10px; color: #ffffff">{{ new Date(mondata).getFullYear() }}年{{ new Date(mondata).getMonth() + 1 }}月</span>
                <div v-if="!truePerson" class="home_datepick">
                    <div class="home_flex">
                        <div class="aside-container">
                            <div v-if="shouzubie" class="search-box">
                                <!-- <el-select ref="multiSelect"  :popper-append-to-body="false" clearable multiple collapse-tags popper-class="selx" @change="depChange" v-model="departids" placeholder="請選擇組別/分行"> -->
                                <!-- :class="['oneone',{twotwo:treeData.length>4}]" -->
                                <!-- <div class="oneone">
                                        <el-option v-for="(item, index) in treeData" :key="index" :value="item.departmentID" :label="item.departmentName">
                                            <span class="check"></span>
                                            <span style="margin-left: 8px">{{ item.departmentName }}</span>
                                        </el-option>
                                    </div>
                                    <div class="btnSel">
                                        <el-button @click="falsedisdep()" size="mini" type="primary">確定</el-button>
                                        <el-button @click="canceldisdep()" size="mini">取消</el-button>
                                    </div>
                                </el-select> -->
                                <el-select ref="multiSelect" :popper-append-to-body="false" popper-class="selx" class="form-input" v-model="departidSel" placeholder="請選擇組別/分行">
                                    <div class="oneone">
                                        <el-cascader-panel
                                            class="wuborder"
                                            v-model="departids"
                                            :options="treeData"
                                            :props="{
                                                multiple: true,
                                                value: 'departmentID',
                                                label: 'departmentName',
                                                checkStrictly: false
                                            }"
                                            collapse-tags
                                            @change="depChange"
                                            :show-all-levels="false"
                                        ></el-cascader-panel>
                                    </div>
                                    <div class="btnSel">
                                        <el-option v-model="departidSel">
                                            <el-button @click="falsedisdep()" size="mini" type="primary">確定</el-button>
                                            <el-button @click="canceldisdep()" size="mini">取消</el-button>
                                        </el-option>
                                    </div>
                                </el-select>
                                <div v-show="departidSel" class="fuclodateicon"></div>
                                <i v-show="departidSel" @click="alldel" class="el-icon-circle-close clodateicon"></i>
                                <!-- <el-cascader
                                    v-model="departids"
                                    class="form-input"
                                    placeholder="請選擇組別/分行"
                                    :options="treeData"
                                    @visible-change="disdep($event)"
                                    @remove-tag="chufa($event)"
                                    :props="{
                                        multiple: true,
                                        value: 'departmentID',
                                        label: 'departmentName',
                                        checkStrictly: false
                                    }"
                                    collapse-tags
                                    @change="depChange"
                                ></el-cascader> -->
                            </div>
                        </div>

                        <el-date-picker popper-class="datedie" ref="dataEnd" :editable="false" :clearable="false" format="yyyy/MM" value-format="timestamp" :picker-options="pickerOptions0" @change="dataPick" class="data_pick" v-model="mondata" type="month" placeholder="选择月"> </el-date-picker>
                        <i v-show="!showup" @click="chooseBg" class="el-icon-arrow-down dateicon"></i>
                        <i v-show="showup" @click="chooseBgup" class="el-icon-arrow-up dateicon"></i>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div style=" overflow:y:scroll"></div> -->
        <!-- 内容选择区 -->
        <div v-loading="loadingDepartmentData" class="home_container">
            <!-- 仅金币或仅钻石  -->
            <div v-if="!truePerson && !(homeinfo.isUseCoin && homeinfo.isUseDiamond) && (homeinfo.isUseCoin || homeinfo.isUseDiamond)">
            <!-- <div v-if="false"> -->
                <!-- 仅金币或仅钻石 当月(total总览) -->
                <el-row v-if="oncoin && oncoin.dataType == 'Total'" style="background-color: #dae9f6; padding: 9px 10px 20px 0; border-top-left-radius: 0; border-top-right-radius: 0; border-bottom-left-radius: 25px; border-bottom-right-radius: 25px">
                    <div class="home-tit" v-if="oncoin.dataType == 'Total'">【{{ oncoin.departmentName }}】用量總覽</div>
                    <el-col style="margin-left: 20px" v-if="homeinfo.isUseDiamond  && !isDisabledPublish" :span="6">
                        <div class="hometwo">
                            <div class="zuocontain">
                                <img style="width: 100%; max-width: 42px; max-height: 42px" src="@/assets/diamond-icon.svg" />
                            </div>
                            <div class="youcontain">
                                <div class="t-dyu-all">
                                    <div style="width: 100%; color: #44444f">鑽石餘額總計</div>
                                    <span v-if="oncoin.currentMonthDiamond == 0 || oncoin.inComeMonthDiamond !== undefined" style="font-size: 40px; font-weight: 700">{{ oncoin.currentMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                                <div class="t-dyu-tongji">
                                    <div class="t-dyu-flextongji">
                                        <span class="font-tit">鑽石存入總計</span>
                                        <span v-if="oncoin.inComeMonthDiamond !== undefined">
                                          <span v-if="oncoin.inComeMonthDiamond >= 0" style="color: #009933; font-size: 18px">{{ oncoin.inComeMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else style="color: #dd2200; font-size: 18px">{{ oncoin.inComeMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                    </div>
                                    <!-- <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">鑽石支出總計</span>
                                        <span v-if="oncoin.payMonthDiamond == 0 || oncoin.payMonthDiamond !== undefined" style="color: #dd2200; font-size: 18px">{{ oncoin.payMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                    </div> -->
                                    <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">鑽石刊登支出總計</span>
                                        <span v-if="oncoin.propertyMonthDiamond !== undefined">
                                          <span v-if="oncoin.propertyMonthDiamond >= 0" style="color: #009933; font-size: 18px">{{ oncoin.propertyMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else style="color: #dd2200; font-size: 18px">{{ oncoin.propertyMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                    </div>
                                    <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">{{oncoin.topTotal ? '鑽石被回收總計' : '鑽石分配/回收淨額'}}</span>
                                        <span v-if="oncoin.payMonthDiamond !== undefined">
                                          <span v-if="oncoin.payMonthDiamond >= 0" style="color: #009933; font-size: 18px">{{ oncoin.payMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else style="color: #dd2200; font-size: 18px">{{ oncoin.payMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div style="margin-top: 15px">
                                    <div style="font-size: 14px">鑽石合約日期</div>
                                    <span v-if="homeinfo.nonediatime" style="font-size: 14px">{{ homeinfo.nonediatime }}</span>
                                    <span v-else style="font-size: 14px">{{ homeinfo.diamondContractStart }} ~ {{ homeinfo.diamondContractEnd }}</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col style="margin-left: 20px" v-if="homeinfo.isUseCoin && !isDisabledPublish" :span="6">
                        <div class="hometwo">
                            <div class="zuocontain">
                                <img style="width: 100%; max-width: 42px; max-height: 42px" src="@/assets/gold-icon.svg" />
                            </div>
                            <div class="youcontain">
                                <div class="t-dyu-all">
                                    <div style="width: 100%; color: #44444f">金幣餘額總計</div>
                                    <span v-if="oncoin.currentMonthCoin == 0 || oncoin.currentMonthCoin !== undefined" style="font-size: 40px; font-weight: 700">{{ oncoin.currentMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                                <div class="t-dyu-tongji">
                                    <div class="t-dyu-flextongji">
                                        <span class="font-tit">金幣存入總計</span>
                                        <span v-if="oncoin.inComeMonthCoin !== undefined">
                                          <span v-if="oncoin.inComeMonthCoin >= 0" style="color: #009933; font-size: 18px">{{ oncoin.inComeMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else style="color: #dd2200; font-size: 18px">{{ oncoin.inComeMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                    </div>
                                    <!-- <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">金幣支出總計</span>
                                        <span v-if="oncoin.payMonthCoin == 0 || oncoin.payMonthCoin !== undefined" style="color: #dd2200; font-size: 18px">{{ oncoin.payMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                    </div> -->
                                    <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">金幣刊登支出總計</span>
                                        <span v-if="oncoin.propertyMonthCoin !== undefined">
                                          <span v-if="oncoin.propertyMonthCoin >= 0" style="color: #009933; font-size: 18px">{{ oncoin.propertyMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else style="color: #dd2200; font-size: 18px">{{ oncoin.propertyMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                    </div>
                                    <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">{{oncoin.topTotal ? '金幣被回收總計' : '金幣分配/回收淨額'}}</span>
                                        <span v-if="oncoin.payMonthCoin !== undefined">
                                          <span v-if="oncoin.payMonthCoin >= 0" style="color: #009933; font-size: 18px">{{ oncoin.payMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else style="color: #dd2200; font-size: 18px">{{ oncoin.payMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div style="margin-top: 15px">
                                    <div style="font-size: 14px">金幣合約日期</div>
                                    <span v-if="homeinfo.nonetime">{{ homeinfo.nonetime }}</span>
                                    <span v-else style="font-size: 14px">{{ homeinfo.coinContractStart }} ~ {{ homeinfo.coinContractEnd }}</span>
                                 </div>
                            </div>
                        </div>
                    </el-col>
                    <!-- v-if="homeinfo.currentMonth && oncoin.dataType == 'Total' && !(homeinfo.isUseCoin && homeinfo.isUseDiamond) && (homeinfo.isUseCoin || homeinfo.isUseDiamond)" -->
                    <el-col style="margin-left: 20px" :span="5">
                        <div class="t-shou-yi">
                            <div class="t-shou-tu">
                                <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/salepro.svg" />
                                <!-- <div class="baoyuan">
                                    <span class="shouyuan">售</span>
                                </div> -->
                            </div>
                            <div class="t-kan-yi">
                                <div style="width: 100%; font-size: 17px; color: #666666">本月已刊登/續期</div>
                                <div style="width: 100%; font-size: 17px; color: #666666">售盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ oncoin.salePropertyCount }}</div>
                            </div>
                            <div class="t-sanpan">
                                <span class="t-xing">
                                    <span>星級</span>
                                    <span>{{ oncoin.saleSuperPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>精選</span>
                                    <span>{{ oncoin.saleTopPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>標準</span>
                                    <span>{{ oncoin.saleStandardPropertyCount }}</span>
                                </span>
                            </div>
                            <!-- 单金币 也要如双货币一般展示星级等盘数量，故先前所写不在展示v-if-false-->
                            <div v-if="false" class="t-kan-yi" style="width: 50%; margin-left: 10px">
                                <div style="width: 100%; font-size: 17px; color: #666666">本月已刊登/續期</div>
                                <div style="width: 100%; font-size: 17px; color: #666666">售盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ oncoin.salePropertyCount }}</div>
                                <template v-if="homeinfo.currentMonth">
                                    <div style="margin-top: 40px; width: 100%; font-size: 18px; color: #666666">顯示中</div>
                                    <div style="width: 100%; font-size: 18px; color: #666666">售盤總計</div>
                                    <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ oncoin.displaySalePropertyCount }}</div>
                                </template>
                                <div v-else style="height: 135px"></div>
                            </div>
                        </div>
                        <div class="t-shou-yi t-shou-er">
                            <div class="t-shou-tu">
                                <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/salepro.svg" />
                            </div>
                            <div class="t-kan-yi">
                                <div style="width: 100%; font-size: 18px; color: #666666">顯示中</div>
                                <div style="width: 100%; font-size: 18px; color: #666666">售盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ oncoin.displaySalePropertyCount }}</div>
                            </div>
                            <div class="t-sanpan">
                                <span class="t-xing">
                                    <span>星級</span>
                                    <span>{{ oncoin.displaySaleSuperPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>精選</span>
                                    <span>{{ oncoin.displaySaleTopPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>標準</span>
                                    <span>{{ oncoin.displaySaleStandardPropertyCount }}</span>
                                </span>
                            </div>
                        </div>
                    </el-col>
                    <!-- v-if="homeinfo.currentMonth && oncoin.dataType == 'Total' && !(homeinfo.isUseCoin && homeinfo.isUseDiamond) && (homeinfo.isUseCoin || homeinfo.isUseDiamond)" -->
                    <el-col style="margin-left: 20px" :span="5">
                        <div class="t-shou-yi">
                            <div class="t-shou-tu">
                                <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/rentpro.svg" />
                                <!-- <div class="baoyuan">
                                    <span class="shouyuan">租</span>
                                </div> -->
                            </div>
                            <div class="t-kan-yi">
                                <div style="width: 100%; font-size: 17px; color: #666666">本月已刊登/續期</div>
                                <div style="width: 100%; font-size: 17px; color: #666666">租盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ oncoin.rentPropertyCount }}</div>
                            </div>
                            <div class="t-sanpan">
                                <span class="t-xing">
                                    <span>星級</span>
                                    <span>{{ oncoin.rentSuperPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>精選</span>
                                    <span>{{ oncoin.rentTopPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>標準</span>
                                    <span>{{ oncoin.rentStandardPropertyCount }}</span>
                                </span>
                            </div>
                            <div v-if="false" class="t-kan-yi" style="width: 50%; margin-left: 10px">
                                <div style="width: 100%; font-size: 17px; color: #666666">本月已刊登/續期</div>
                                <div style="width: 100%; font-size: 17px; color: #666666">租盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ oncoin.rentPropertyCount }}</div>
                                <template v-if="homeinfo.currentMonth">
                                    <div style="margin-top: 40px; width: 100%; font-size: 18px; color: #666666">顯示中</div>
                                    <div style="width: 100%; font-size: 18px; color: #666666">租盤總計</div>
                                    <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ oncoin.displayRentPropertyCount }}</div>
                                </template>
                                <div v-else style="height: 135px"></div>
                            </div>
                        </div>
                        <div class="t-shou-yi t-shou-er">
                            <div class="t-shou-tu">
                                <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/rentpro.svg" />
                            </div>
                            <div class="t-kan-yi">
                                <div style="width: 100%; font-size: 18px; color: #666666">顯示中</div>
                                <div style="width: 100%; font-size: 18px; color: #666666">租盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ oncoin.displayRentPropertyCount }}</div>
                            </div>
                            <div class="t-sanpan">
                                <span class="t-xing">
                                    <span>星級</span>
                                    <span>{{ oncoin.displayRentSuperPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>精選</span>
                                    <span>{{ oncoin.displayRentTopPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>標準</span>
                                    <span>{{ oncoin.displayRentStandardPropertyCount }}</span>
                                </span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <!-- 仅金币或仅钻石 当月(概览) -->
                <!-- <el-row v-if="showdepData.length !== 0 && showdepData !== null"> -->
                <el-row v-if="false">
                    <el-col :span="12" v-for="(item, index) in showdepData" :key="index">
                        <!-- 为col加分界线 -->
                        <div :class="index == 0 || index == 1 || (index == showdepData.length - 1 && showdepData.length % 2 !== 0) ? '' : 'oncoin-div'"></div>
                        <div class="home-tit">【{{ item.departmentName }}】用量概覽</div>
                        <el-col style="margin-left: 10px" v-if="homeinfo.isUseDiamond && !isDisabledPublish" :span="12">
                            <div class="hometwo">
                                <div class="zuocontain">
                                    <img style="width: 100%; max-width: 42px; max-height: 42px" src="@/assets/diamond-icon.svg" />
                                </div>
                                <div class="youcontain">
                                    <div class="t-dyu-all">
                                        <div style="width: 100%; color: #44444f">鑽石餘額總計</div>
                                        <span v-if="item.currentMonthDiamond == 0 || item.currentMonthDiamond !== undefined" style="font-size: 40px; font-weight: 700">{{ item.currentMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                    </div>
                                    <div class="t-dyu-tongji">
                                        <div class="t-dyu-flextongji">
                                            <span class="font-tit">鑽石存入總計</span>
                                            <span v-if="item.inComeMonthDiamond !== undefined">
                                              <span v-if="item.inComeMonthDiamond >= 0" style="color: #009933; font-size: 18px">{{ item.inComeMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                              <span v-else style="color: #dd2200; font-size: 18px">{{ item.inComeMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                            </span>
                                        </div>
                                        <!-- <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                            <span class="font-tit">鑽石支出總計</span>
                                            <span v-if="item.payMonthDiamond == 0 || item.payMonthDiamond !== undefined" style="color: #dd2200; font-size: 18px">{{ item.payMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </div> -->
                                         <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                            <span class="font-tit">鑽石刊登支出總計</span>
                                            <span v-if="item.propertyMonthDiamond !== undefined">
                                              <span v-if="item.propertyMonthDiamond >= 0" style="color: #009933; font-size: 18px">{{ item.propertyMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                              <span v-else style="color: #dd2200; font-size: 18px">{{ item.propertyMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                            </span>
                                        </div>
                                        <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                            <span class="font-tit">{{item.topTotal ? '鑽石被回收總計' : '鑽石分配/回收淨額'}}</span>
                                            <span v-if="item.payMonthDiamond !== undefined">
                                              <span v-if="item.payMonthDiamond >= 0" style="color: #009933; font-size: 18px">{{ item.payMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                              <span v-else style="color: #dd2200; font-size: 18px">{{ item.payMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div style="margin-top: 15px">
                                        <div style="font-size: 14px">鑽石合約日期</div>
                                        <span v-if="homeinfo.nonediatime" style="font-size: 14px">{{ homeinfo.nonediatime }}</span>
                                        <span v-else style="font-size: 14px">{{ homeinfo.diamondContractStart }} ~ {{ homeinfo.diamondContractEnd }}</span>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col style="margin-left: 10px" v-if="homeinfo.isUseCoin && !isDisabledPublish" :span="12">
                            <div class="hometwo">
                                <div class="zuocontain">
                                    <img style="width: 100%; max-width: 42px; max-height: 42px" src="@/assets/gold-icon.svg" />
                                </div>
                                <div class="youcontain">
                                    <div class="t-dyu-all">
                                        <div style="width: 100%; color: #44444f">金幣餘額總計</div>
                                        <span v-if="item.currentMonthCoin == 0 || item.currentMonthCoin !== undefined" style="font-size: 40px; font-weight: 700">{{ item.currentMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                    </div>
                                    <div class="t-dyu-tongji">
                                        <div class="t-dyu-flextongji">
                                            <span class="font-tit">金幣存入總計</span>
                                            <span v-if="item.inComeMonthCoin !== undefined">
                                              <span v-if="item.inComeMonthCoin >= 0" style="color: #009933; font-size: 18px">{{ item.inComeMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                              <span v-else style="color: #dd2200; font-size: 18px">{{ item.inComeMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                            </span>
                                        </div>
                                        <!-- <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                            <span class="font-tit">金幣支出總計</span>
                                            <span v-if="item.payMonthCoin == 0 || item.payMonthCoin !== undefined" style="color: #dd2200; font-size: 18px">{{ item.payMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </div> -->
                                        <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                          <span class="font-tit">金幣刊登支出總計</span>
                                          <span v-if="item.propertyMonthCoin !== undefined" style="color: #009933; font-size: 18px">
                                            <span v-if="item.propertyMonthCoin >= 0">{{ item.propertyMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                            <span v-else  style="color: #dd2200; font-size: 18px">{{ item.propertyMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          </span>
                                        </div>
                                        <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                            <span class="font-tit">{{item.topTotal ? '金幣被回收總計' : '金幣分配/回收淨額'}}</span>
                                            <span v-if="item.payMonthCoin !== undefined">
                                              <span v-if="item.payMonthCoin >= 0" style="color: #009933; font-size: 18px">{{ item.payMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                              <span v-else style="color: #dd2200; font-size: 18px">{{ item.payMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div style="margin-top: 15px">
                                        <div style="font-size: 14px">金幣合約日期</div>
                                        <span v-if="homeinfo.nonetime">{{ homeinfo.nonetime }}</span>
                                        <span v-else style="font-size: 14px">{{ homeinfo.coinContractStart }} ~ {{ homeinfo.coinContractEnd }}</span>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col style="margin-left: 20px; padding-bottom: 20px" :span="10">
                            <div class="t-oncoinshou-yi">
                                <div class="t-shou-tu">
                                    <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/salepro.svg" />

                                    <!-- <div class="baoyuan">
                                        <span class="shouyuan">售</span>
                                    </div> -->
                                </div>
                                <div class="t-kan-yi">
                                    <div style="width: 100%; font-size: 17px; color: #666666">本月已刊登/續期</div>
                                    <div style="width: 100%; font-size: 17px; color: #666666">售盤總計</div>
                                    <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ item.salePropertyCount }}</div>
                                </div>
                                <div v-if="homeinfo.currentMonth" class="t-oncoinsanpan">
                                    <div style="width: 100%; font-size: 17px; color: #666666">顯示中</div>
                                    <div style="width: 100%; font-size: 17px; color: #666666">售盤總計</div>
                                    <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ item.displaySalePropertyCount }}</div>
                                </div>
                            </div>

                            <div class="t-oncoinshou-yi t-shou-er">
                                <div class="t-shou-tu">
                                    <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/rentpro.svg" />
                                    <!-- <div class="baoyuan">
                                        <span class="shouyuan">租</span>
                                    </div> -->
                                </div>
                                <div class="t-kan-yi">
                                    <div style="width: 100%; font-size: 17px; color: #666666">本月已刊登/續期</div>
                                    <div style="width: 100%; font-size: 17px; color: #666666">租盤總計</div>
                                    <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ item.rentPropertyCount }}</div>
                                </div>
                                <div v-if="homeinfo.currentMonth" class="t-oncoinsanpan">
                                    <div style="width: 100%; font-size: 17px; color: #666666">顯示中</div>
                                    <div style="width: 100%; font-size: 17px; color: #666666">租盤總計</div>
                                    <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ item.displayRentPropertyCount }}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-col>
                </el-row>
            </div>

            <!-- 金币钻石都有-->
             <!-- 0528应hk要求，单金币也展示星级等数量。故单金币的概览和双货币的概览采用同一套代码（单金币的item.dataType无total所以总览是分开的） -->
            <!-- <div v-if="!truePerson && homeinfo.isUseCoin && homeinfo.isUseDiamond && showdepData.length !== 0 && showdepData !== null"> -->
                <div v-if="!truePerson && showdepData.length !== 0 && showdepData !== null">
                <el-row style="margin-left: 0; margin-right: 0; padding-top: 10px" :gutter="20" :class="item.dataType == 'Total' ? 'totalclass' : ''" v-for="(item, index) in showdepData" :key="index">
                    <div class="home-tit" v-if="item.dataType == 'Total'">【{{ item.departmentName }}】用量總覽</div>
                    <div class="home-tit" v-else>【{{ item.departmentName }}】用量概覽</div>
                    <el-col v-if="homeinfo.isUseDiamond && !isDisabledPublish" :span="6">
                        <div class="hometwo">
                            <div class="zuocontain">
                                <img style="width: 100%; min-width: 21px; min-height: 21px; max-width: 42px; max-height: 42px" src="@/assets/diamond-icon.svg" />
                            </div>
                            <div class="youcontain">
                                <div class="t-dyu-all">
                                    <div style="width: 100%; color: #44444f">鑽石餘額總計</div>
                                    <span v-if="item.currentMonthDiamond == 0 || item.currentMonthDiamond !== undefined" style="font-size: 40px; font-weight: 700">{{ item.currentMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                                <div class="t-dyu-tongji">
                                    <div class="t-dyu-flextongji">
                                        <!-- <span class="font-tit">鑽石{{item.dataType == 'Total'?'存':'收'}}入總計</span> -->
                                        <span class="font-tit">鑽石存入總計</span>
                                        <span v-if="item.inComeMonthDiamond !== undefined">
                                          <span v-if="item.inComeMonthDiamond >= 0" style="color: #009933; font-size: 18px">{{ item.inComeMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else style="color: #dd2200; font-size: 18px">{{ item.inComeMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                    </div>
                                    <!-- <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">鑽石支出總計</span>
                                        <span v-if="item.payMonthDiamond == 0 || item.payMonthDiamond !== undefined" style="color: #dd2200; font-size: 18px">{{ item.payMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                    </div> -->
                                    <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">鑽石刊登支出總計</span>
                                        <span v-if="item.propertyMonthDiamond !== undefined">
                                          <span v-if="item.propertyMonthDiamond >= 0" style="color: #009933; font-size: 18px">{{ item.propertyMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else style="color: #dd2200; font-size: 18px">{{ item.propertyMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                    </div>
                                    <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">{{item.topTotal ? '鑽石被回收總計' : '鑽石分配/回收淨額'}}</span>
                                        <span v-if="item.payMonthDiamond !== undefined">
                                          <span v-if="item.payMonthDiamond >= 0" style="color: #009933; font-size: 18px">{{ item.payMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else style="color: #dd2200; font-size: 18px">{{ item.payMonthDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div style="margin-top: 15px">
                                    <div style="font-size: 14px">鑽石合約日期</div>
                                    <span v-if="homeinfo.nonediatime" style="font-size: 14px">{{ homeinfo.nonediatime }}</span>
                                    <span v-else style="font-size: 14px">{{ homeinfo.diamondContractStart }} ~ {{ homeinfo.diamondContractEnd }}</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col v-if="homeinfo.isUseCoin && !isDisabledPublish" :span="6">
                        <div class="hometwo">
                            <div class="zuocontain">
                                <img style="width: 100%; width: 100%; max-width: 42px; max-height: 42px; min-width: 21px; min-height: 21px" src="@/assets/gold-icon.svg" />
                            </div>
                            <div class="youcontain">
                                <div class="t-dyu-all">
                                    <div style="width: 100%; color: #44444f">金幣餘額總計</div>
                                    <span v-if="item.currentMonthCoin == 0 || item.currentMonthCoin !== undefined" style="font-size: 40px; font-weight: 700">{{ item.currentMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                                <div class="t-dyu-tongji">
                                    <div class="t-dyu-flextongji">
                                        <!-- <span class="font-tit">金幣{{item.dataType == 'Total'?'存':'收'}}入總計</span> -->
                                        <span class="font-tit">金幣存入總計</span>
                                        <span v-if="item.inComeMonthCoin !== undefined" style="color: #009933; font-size: 18px">
                                          <span v-if="item.inComeMonthCoin >= 0" style="color: #009933; font-size: 18px">{{ item.inComeMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else style="color: #dd2200; font-size: 18px">{{ item.inComeMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                    </div>
                                    <!-- <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">金幣支出總計</span>
                                        <span v-if="item.payMonthCoin == 0 || item.payMonthCoin !== undefined" style="color: #dd2200; font-size: 18px">{{ item.payMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                    </div> -->
                                      <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                        <span class="font-tit">金幣刊登支出總計</span>
                                        <span v-if="item.propertyMonthCoin !== undefined" style="color: #009933; font-size: 18px">
                                          <span v-if="item.propertyMonthCoin >= 0">{{ item.propertyMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          <span v-else  style="color: #dd2200; font-size: 18px">{{ item.propertyMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                        </span>
                                      </div>
                                      <div class="t-dyu-flextongji t-dyu-flextongji-t">
                                          <span class="font-tit">{{item.topTotal ? '金幣被回收總計' : '金幣分配/回收淨額'}}</span>
                                          <span v-if="item.payMonthCoin !== undefined">
                                            <span v-if="item.payMonthCoin >= 0" style="color: #009933; font-size: 18px">{{ item.payMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                            <span v-else style="color: #dd2200; font-size: 18px">{{ item.payMonthCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                          </span>
                                      </div>
                                </div>
                                <div style="margin-top: 15px">
                                    <div style="font-size: 14px">金幣合約日期</div>
                                    <span v-if="homeinfo.nonetime">{{ homeinfo.nonetime }}</span>
                                    <span v-else style="font-size: 14px">{{ homeinfo.coinContractStart }} ~ {{ homeinfo.coinContractEnd }}</span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <!-- 金币钻石 当月 -->
                    <!-- <el-col v-if="homeinfo.currentMonth && homeinfo.isUseCoin && homeinfo.isUseDiamond" :span="6"> -->
                    <el-col v-if="homeinfo.currentMonth" :span="6">
                        <div class="t-shou-yi">
                            <div class="t-shou-tu">
                                <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/salepro.svg" />
                                <!-- <div class="baoyuan">
                                    <span class="shouyuan">售</span>
                                </div> -->
                            </div>
                            <div class="t-kan-yi">
                                <div style="width: 100%; font-size: 17px; color: #666666">本月已刊登/續期</div>
                                <div style="width: 100%; font-size: 17px; color: #666666">售盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ item.salePropertyCount }}</div>
                            </div>
                            <div class="t-sanpan">
                                <span class="t-xing">
                                    <span>星級</span>
                                    <span>{{ item.saleSuperPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>精選</span>
                                    <span>{{ item.saleTopPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>標準</span>
                                    <span>{{ item.saleStandardPropertyCount }}</span>
                                </span>
                            </div>
                        </div>

                        <div class="t-shou-yi t-shou-er">
                            <div class="t-shou-tu">
                                <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/salepro.svg" />
                                <!-- <div class="baoyuan">
                                    <span class="shouyuan">售</span>
                                </div> -->
                            </div>
                            <div class="t-kan-yi">
                                <div style="width: 100%; font-size: 18px; color: #666666">顯示中</div>
                                <div style="width: 100%; font-size: 18px; color: #666666">售盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ item.displaySalePropertyCount }}</div>
                            </div>
                            <div class="t-sanpan">
                                <span class="t-xing">
                                    <span>星級</span>
                                    <span>{{ item.displaySaleSuperPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>精選</span>
                                    <span>{{ item.displaySaleTopPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>標準</span>
                                    <span>{{ item.displaySaleStandardPropertyCount }}</span>
                                </span>
                            </div>
                        </div>
                    </el-col>
                    <!-- <el-col v-if="homeinfo.currentMonth && homeinfo.isUseCoin && homeinfo.isUseDiamond" :span="6"> -->
                    <el-col v-if="homeinfo.currentMonth" :span="6">
                        <div class="t-shou-yi">
                            <div class="t-shou-tu">
                                <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/rentpro.svg" />
                                <!-- <div class="baoyuan">
                                    <span class="shouyuan">租</span>
                                </div> -->
                            </div>
                            <div class="t-kan-yi">
                                <div style="width: 100%; font-size: 17px; color: #666666">本月已刊登/續期</div>
                                <div style="width: 100%; font-size: 17px; color: #666666">租盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ item.rentPropertyCount }}</div>
                            </div>
                            <div class="t-sanpan">
                                <span class="t-xing">
                                    <span>星級</span>
                                    <span>{{ item.rentSuperPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>精選</span>
                                    <span>{{ item.rentTopPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>標準</span>
                                    <span>{{ item.rentStandardPropertyCount }}</span>
                                </span>
                            </div>
                        </div>

                        <div class="t-shou-yi t-shou-er">
                            <div class="t-shou-tu">
                                <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/rentpro.svg" />
                                <!-- <div class="baoyuan">
                                    <span class="shouyuan">租</span>
                                </div> -->
                            </div>
                            <div class="t-kan-yi">
                                <div style="width: 100%; font-size: 18px; color: #666666">顯示中</div>
                                <div style="width: 100%; font-size: 18px; color: #666666">租盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ item.displayRentPropertyCount }}</div>
                            </div>
                            <div class="t-sanpan">
                                <span class="t-xing">
                                    <span>星級</span>
                                    <span>{{ item.displayRentSuperPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>精選</span>
                                    <span>{{ item.displayRentTopPropertyCount }}</span>
                                </span>
                                <span class="t-xing">
                                    <span>標準</span>
                                    <span>{{ item.displayRentStandardPropertyCount }}</span>
                                </span>
                            </div>
                        </div>
                    </el-col>
                    <!-- 金币钻石 历史 -->
                    <!-- <el-col v-if="!homeinfo.currentMonth && homeinfo.isUseCoin && homeinfo.isUseDiamond" :span="6"> -->
                    <el-col v-if="!homeinfo.currentMonth" :span="6">
                        <div class="t-lishishou-yi">
                            <div class="t-shou-tu">
                                <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/salepro.svg" />
                                <!-- <div class="baoyuan">
                                    <span class="shouyuan">售</span>
                                </div> -->
                            </div>
                            <div class="t-kan-yi">
                                <div style="width: 100%; font-size: 17px; color: #666666">本月已刊登/續期</div>
                                <div style="width: 100%; font-size: 17px; color: #666666">售盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ item.salePropertyCount }}</div>
                                <div class="t-sanpan">
                                    <span class="t-xing">
                                        <span>星級</span>
                                        <span>{{ item.saleSuperPropertyCount }}</span>
                                    </span>
                                    <span class="t-xing">
                                        <span>精選</span>
                                        <span>{{ item.saleTopPropertyCount }}</span>
                                    </span>
                                    <span class="t-xing">
                                        <span>標準</span>
                                        <span>{{ item.saleStandardPropertyCount }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <!-- <el-col v-if="!homeinfo.currentMonth && homeinfo.isUseCoin && homeinfo.isUseDiamond" :span="6"> -->
                    <el-col v-if="!homeinfo.currentMonth" :span="6">
                        <div class="t-lishishou-yi">
                            <div class="t-shou-tu">
                                <img style="width: 100%; max-width: 30px; max-height: 30px; min-width: 21px; min-height: 21px" src="@/assets/rentpro.svg" />
                                <!-- <div class="baoyuan">
                                    <span class="shouyuan">租</span>
                                </div> -->
                            </div>
                            <div class="t-kan-yi">
                                <div style="width: 100%; font-size: 17px; color: #666666">本月已刊登/續期</div>
                                <div style="width: 100%; font-size: 17px; color: #666666">租盤總計</div>
                                <div style="font-size: 30px; font-weight: 700; margin-top: 7px">{{ item.rentPropertyCount }}</div>
                                <div class="t-sanpan">
                                    <span class="t-xing">
                                        <span>星級</span>
                                        <span>{{ item.rentSuperPropertyCount }}</span>
                                    </span>
                                    <span class="t-xing">
                                        <span>精選</span>
                                        <span>{{ item.rentTopPropertyCount }}</span>
                                    </span>
                                    <span class="t-xing">
                                        <span>標準</span>
                                        <span>{{ item.rentStandardPropertyCount }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <!-- 个人数据 -->
            <div v-if="truePerson">
                <el-row :gutter="20" style="margin-left: 0; margin-right: 0; border-top-left-radius: 0; border-top-right-radius: 0; border-bottom-left-radius: 25px; border-bottom-right-radius: 25px; padding: 30px 15px 30px 25px">
                    <el-col :span="14">
                        <div class="geren">
                            <div v-if="isUsedDiamond" :class="['geren-zuo', { gerenzuoa: isUsedCoin == true }]">
                                <div class="zuocontain">
                                    <img style="width: 100%; max-width: 42px; max-height: 42px" src="@/assets/diamond-icon.svg" />
                                </div>
                                <div class="geren-zuoin">
                                    <span v-if="userCoinData.currentDiamond == 0 || userCoinData.currentDiamond !== undefined" style="font-size: 42px; font-weight: 700; color: #44444f">{{ userCoinData.currentDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                    <span style="font-size: 22px; color: #44444f">目前鑽石數量</span>
                                    <span v-if="userCoinData.currentDiamond == 0 || userCoinData.currentDiamond !== undefined" style="margin-top: 10px; font-size: 18px; color: #666666">上月結餘：{{ userCoinData.lastDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                                <div class="geren-zuoin" style="margin-left: 15px">
                                    <span class="geren-zuoin-hui">分配獲得</span>
                                    <span v-if="userCoinData.distributionDiamond == 0 || userCoinData.distributionDiamond !== undefined" class="geren-zuoin-xia">{{ userCoinData.distributionDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                                <div class="geren-zuoin">
                                    <span class="geren-zuoin-hui">使用鑽石</span>
                                    <span v-if="userCoinData.useDiamond == 0 || userCoinData.useDiamond !== undefined" class="geren-zuoin-xia">{{ userCoinData.useDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                                <div class="geren-zuoin">
                                    <span class="geren-zuoin-hui">被回收</span>
                                    <span v-if="userCoinData.superiorRecoveryDiamond == 0 || userCoinData.superiorRecoveryDiamond !== undefined" class="geren-zuoin-xia">{{ userCoinData.superiorRecoveryDiamond.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                            </div>
                            <div v-if="isUsedCoin" class="geren-zuo">
                                <div class="zuocontain">
                                    <img style="width: 100%; max-width: 42px; max-height: 42px" src="@/assets/gold-icon.svg" />
                                </div>
                                <div class="geren-zuoin">
                                    <span v-if="userCoinData.currentCoin == 0 || userCoinData.distributionCoin !== undefined" style="font-size: 42px; font-weight: 700; color: #44444f">{{ userCoinData.currentCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                    <span style="font-size: 22px; color: #44444f">目前金幣數量</span>
                                    <span v-if="userCoinData.currentCoin == 0 || userCoinData.distributionCoin !== undefined" style="margin-top: 10px; font-size: 18px; color: #666666">上月結餘：{{ userCoinData.lastCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                                <div class="geren-zuoin" style="margin-left: 15px">
                                    <span class="geren-zuoin-hui">分配獲得</span>
                                    <span v-if="userCoinData.distributionCoin == 0 || userCoinData.distributionCoin !== undefined" class="geren-zuoin-xia">{{ userCoinData.distributionCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }} </span>
                                </div>
                                <div class="geren-zuoin">
                                    <span class="geren-zuoin-hui">使用金幣</span>
                                    <span v-if="userCoinData.useCoin == 0 || userCoinData.useCoin !== undefined" class="geren-zuoin-xia">{{ userCoinData.useCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                                <div class="geren-zuoin">
                                    <span class="geren-zuoin-hui">被回收</span>
                                    <span v-if="userCoinData.superiorRecoveryCoin == 0 || userCoinData.superiorRecoveryCoin !== undefined" class="geren-zuoin-xia">{{ userCoinData.superiorRecoveryCoin.toString().replace(/(?=(\B\d{3})+$)/g, ',') }}</span>
                                </div>
                            </div>
                            <div v-if="!isUsedDiamond || !isUsedCoin" style="height: 107px"></div>
                        </div>
                    </el-col>
                    <el-col :span="10">
                        <div class="gerenbox">
                            <div class="geren-you-tit">個人放盤數（有效期內，包括顯示/隱藏）</div>
                            <div :class="['geren-you',{ gerenyoua: (isUsedCoin == false && isUsedDiamond == true) || (isUsedCoin == true && isUsedDiamond == false) }]">
                                <div class="geren-you-pan">
                                    <div>
                                        <div class="geren-shouzu">
                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;售盤</span>
                                            <span>租盤</span>
                                        </div>
                                        <!--  v-if="isUsedDiamond && isUsedCoin" -->
                                        <div class="geren-sipan">
                                            <span style="color: #44444f">總數&nbsp;&nbsp;&nbsp;</span>
                                            <span style="color: #44444f" @click="gotoProperty(commands.total, 1)">{{ currentUserPropertyData.salePropertyCount }}</span>
                                            <span style="color: #44444f" @click="gotoProperty(commands.total, 2)">{{ currentUserPropertyData.rentPropertyCount }}</span>
                                        </div>
                                        <!--  v-if="isUsedDiamond" -->
                                        <div class="geren-sipan">
                                            <span>星級盤</span>
                                            <span @click="gotoProperty(commands.starProperty, 1)">{{ currentUserPropertyData.starSalePropertyCount }}</span>
                                            <span @click="gotoProperty(commands.starProperty, 2)">{{ currentUserPropertyData.starRentPropertyCount }}</span>
                                        </div>
                                        <!--  v-if="isUsedDiamond" -->
                                        <div class="geren-sipan">
                                            <span>精選盤</span>
                                            <span @click="gotoProperty(commands.superTop, 1)">{{ currentUserPropertyData.goldTopSalePropertyCount }}</span>
                                            <span @click="gotoProperty(commands.superTop, 2)">{{ currentUserPropertyData.goldTopRentPropertyCount }}</span>
                                        </div>
                                        <!--  v-if="isUsedCoin" -->
                                        <div class="geren-sipan">
                                            <span>標準盤</span>
                                            <span @click="gotoProperty(commands.normal, 1)">{{ currentUserPropertyData.normalSalePropertyCount }}</span>
                                            <span @click="gotoProperty(commands.normal, 2)">{{ currentUserPropertyData.normalRentPropertyCount }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="geren-you-panzhong">
                                    <div>
                                        即將到期樓盤：<span style="color: #0064ff" @click="gotoPropertyinfo(Commandsinfo.expiring)">{{ currentUserPropertyData.nowWillExpireSalePropertyCount + currentUserPropertyData.nowWillExpireRentPropertyCount }}</span>
                                    </div>
                                    <div class="panzhongdiv">
                                        已過期樓盤：<span style="color: #0064ff" @click="gotoPropertyinfo(Commandsinfo.expired)">{{ currentUserPropertyData.expiredSalePropertyCount + currentUserPropertyData.expiredRentPropertyCount }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        </div>
        <!-- 配合新版本上线  提示弹窗 -->
        <el-dialog title="提示" class="new-version-popup" top="30vh" width="420px" :visible.sync="isNewVersionPopupPrompt">
            <div class="new-version-popup-notice" v-html="popupMessage"></div>
            <div class="new-version-popup-btn">
                <el-button type="primary" @click="isNewVersionPopupPrompt = false">確 認</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'HomePage',
    data() {
        return {
            shouzubie: true,
            lazyLoadingAva: true,
            defaultAvatar: require('../../assets/default-avatar.svg'),
            mondata: '', //选中的时间
            postMonData: '',
            getDate: '',
            treeData: [], //组别数据
            departids: [], //选中的组别
            departidSel: '', //选择显示选中几个数据的
            depData: [], //后台返回未经筛选的数据
            showdepData: [], //页面渲染数据
            homeinfo: {
                coinContractEnd: '',
                coinContractStart: '',
                currentMonth: '',
                diamondContractEnd: '',
                diamondContractStart: '',
                isUseCoin: '',
                isUseDiamond: '',
                nonetime: '',
                nonediatime: ''
            },
            oncoin: {}, //仅有金币或者钻石的总览
            flag: false, //是否需要展示全部数据
            departidsbymonth: [],
            truePerson: true,
            userCoinData: '',
            currentUserPropertyData: '',
            commands: {
                total: 'total', // 总数
                superTop: 'superTop', //精选盘
                top: 'top', //置顶盘
                normal: 'normal', //标准盘
                starProperty: 'starProperty' //星级盘
            },
            Commandsinfo: {
                expiring: 'expiringProperty',
                expired: 'expiredProperty',
                personalOrder: 'pendingOrder'
            },
            isNewVersionPopupPrompt: false,
            popupMessage: '',
            selectedTotal: false,
            loadingDepartmentData: true,
            pickerOptions0: {
                //日期选择时间限制
                // disabledDate(time) {
                //     return time.getTime() > Date.now() - 8.64e6 //如果没有后面的-8.64e6就是不可以选择今天的
                // }
                disabledDate: this.disabledDate
            },
            indexMinDateTime: '',
            isDisabledPublish:false,//原companyType0正常显示 1中原住宅 2中原工商（等同该字段为true）,.
            isUsedDiamond: true,
            isUsedCoin: true,
            setID:'',
            quanFlag: false,
            cancelids: [],
            showup: false,
        };
    },
    // destroyed(){
    //     console.log("dessss")
    //     this.desDiv = false
    // },
    watch: {
        departidSel(value) {
            if (value == '已選擇0項') {
                this.departidSel = '';
                this.departids = [];
            }
        }
    },
    computed: {
        ...mapGetters(['userInfo', 'accessRoutePage']),
        userImg() {
            return this.userInfo.imagePath ? this.pub.imgResize(this.userInfo.imagePath, 'user') : this.defaultAvatar;
        }
    },
    async created() {
        await this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
            if (res.data.code === 0 && res.data.result) {
                this.setID = res.data.result.setID;
                // console.log(res.data.result.setID,"第一个执行",this.setID)
                window.googletag = window.googletag || {cmd: []};
                let _this = this
                try {
                    googletag.destroySlots() 
                    document.querySelector('#div-gpt-ad-1682322729799-0').setAttribute('data-google-query-id', '') 
                    document.querySelector('#div-gpt-ad-1682322729799-0').innerHTML = '' 
                    setTimeout(() => {
                        googletag.cmd.push(function() {
                            googletag.defineSlot('/22338996054/PMS_PC_728x90_Homepage_Banner', [728, 90], 'div-gpt-ad-1682322729799-0').addService(googletag.pubads());
                            googletag.pubads().setTargeting('CompanyConfig', [`${_this.setID}`]);
                            googletag.pubads().enableSingleRequest();
                            googletag.pubads().collapseEmptyDivs();
                            googletag.enableServices();
                        });
                        googletag.cmd.push(function() { googletag.display('div-gpt-ad-1682322729799-0'); });
                    }, 100);
                } catch (error) {
                    console.log("GoogleAdsense:",error)
                }
                this.isDisabledPublish = res.data.result.isDisabledPublish
                this.isUsedDiamond = res.data.result.isUsedDiamond;
                this.isUsedCoin = res.data.result.isUsedCoin;
                // let a = '2022-02-28T00:00:00'
                // this.indexMinDateTime = a.split('T')[0].getTime();

                this.indexMinDateTime = new Date(res.data.result.indexMinDateTime.split('T')[0]).getTime();
                // 是否展示楼盘数据
                this.isUseRealEstate = {
                    isUseStandard: res.data.result.isUseStandard,
                    isUseStar: res.data.result.isUseStar,
                    isUseSuper: res.data.result.isUseSuper
                };
            }
        });
        if (!this.userInfo.roleName || JSON.stringify(this.userInfo) === '{}') {
            await this.pub.obtainAndSetUserInfo();
        }
        
        // 14期和首页合并
        /**配合新版本上线  提示弹窗*/
        this.axios.get(this.pub.getApi().GetPopupMessage).then(res => {
            if (res.data.code === 0 && res.data.result.popupMessage) {
                // 换行空格替换为br
                this.popupMessage = res.data.result.popupMessage.replace(/\\r\\n/g, '<br><br>');
                this.popupMessage = this.popupMessage.replace(/\n/g, '<br>');
                let date = new Date();
                let time = `${date.getFullYear()}${date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)}${date.getDate() > 9 ? date.getDate() : '0' + date.getDate()}`;
                if (localStorage.getItem('newVersionPopupPrompt')) {
                    let locTime = localStorage.getItem('newVersionPopupPrompt');
                    if (locTime < time) {
                        this.isNewVersionPopupPrompt = true;
                        localStorage.setItem('newVersionPopupPrompt', time);
                    }
                } else {
                    this.isNewVersionPopupPrompt = true;
                    localStorage.setItem('newVersionPopupPrompt', time);
                }
            }
        });
        
        this.flag = true; //初始需要展示全部数据
        this.getdatatime();
        this.getDepartmentsTree();
        this.loadGetPermission(); //是否要展示個人數據
    },
    mounted() {
        googletag.cmd.push(function() { googletag.display('div-gpt-ad-1682322729799-0'); });

        /**页面引导 ---------- */
        /**暂时 guideType 有 roleID权限id 后期再加引导页需要调整*/
        if (this.userInfo.roleID) {
            this.axios
                .post(this.pub.getApi().GetAccountGuide, {
                    guideType: this.userInfo.roleID
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.guidePage(true);
                    }
                    // else {
                    //     this.showTips();
                    // }
                });
            if (this.$route.params.initiativeGuide) {
                this.guidePage(false);
            }
        }
    },
    methods: {
        ...mapActions(['setPage']),
        alldel() {
            this.quanFlag = false;
            this.departidSel = '';
            this.departids = [];
            // 全部清除时,展示全部数据
            this.getDepartmentData('second', 'dateF');      
        },
        // 点击下拉控制弹出
        chooseBg() {
            this.showup = true;
            this.$refs.dataEnd.focus();
        },
        chooseBgup() {
            this.showup = false;
            this.$refs.dataEnd.blur();
        },
        // 禁止选择的日期时间
        disabledDate(time) {
            // 获取今天以及以前的日期 或者 创建之前的日期
            if (time.getTime() > Date.now() - 8.64e6 || time.getTime() + 86399000 < this.indexMinDateTime ) {
                return true;
            }
        },
        // 个人数据 点击跳转
        gotoProperty(command, item) {
            let queryData = {
                rentaltype: item,
                paymentstatus: 1,
                due: 'notexpired'
            };
            if (this.truePerson) {
                queryData['searchaccountpropertytype'] = 'owner';
                queryData['accountid'] = this.userInfo.accountID;
            }else{
                queryData['departmentid'] = this.userInfo.departmentID;
            }
            // if (this.type === 'personal') {
            //     queryData['searchaccountpropertytype'] = 'owner';
            //     queryData['accountid'] = this.userInfo.accountID;
            // } else if (this.type === 'department') {
            //     queryData['departmentid'] = this.userInfo.departmentID;
            // }

            if (command === this.commands.superTop) {
                queryData['topoption'] = 1;
            } else if (command === this.commands.top) {
                queryData['topoption'] = 2;
            } else if (command === this.commands.normal) {
                queryData['topoption'] = 0;
            } else if (command === this.commands.starProperty) {
                queryData['topoption'] = 3;
            }
            this.$router
                .push({ name: this.pub.routeNameLists.PropertyIndex, params: queryData })
                .then(() => {
                    this.setPage({
                        nowPage: this.accessRoutePage[this.pub.routeNameLists.PropertyIndex].nowPage,
                        labelsPage: this.accessRoutePage[this.pub.routeNameLists.PropertyIndex].labelsPage
                    });
                })
                .catch(err => {
                    console.log(err);
                });
        },
        gotoPropertyinfo(command) {
            let queryData = {};
            if (command === this.Commandsinfo.expiring) {
                queryData = {
                    accountid: `${this.userInfo.accountID}`,
                    searchaccountpropertytype: 'owner',
                    due: 'will',
                    paymentstatus: 1
                };
            } else if (command === this.Commandsinfo.expired) {
                queryData = {
                    accountid: `${this.userInfo.accountID}`,
                    searchaccountpropertytype: 'owner',
                    due: 'over',
                    paymentstatus: 1
                };
            } else if (command === this.Commandsinfo.personalOrder) {
                queryData = {
                    accountid: `${this.userInfo.accountID}`,
                    searchaccountpropertytype: 'owner',
                    paymentstatus: 0
                };
            }
            this.$router
                .push({
                    name: this.pub.routeNameLists.PropertyIndex,
                    params: queryData
                })
                .then(
                    this.setPage({
                        nowPage: this.accessRoutePage[this.pub.routeNameLists.PropertyIndex].nowPage,
                        labelsPage: this.accessRoutePage[this.pub.routeNameLists.PropertyIndex].labelsPage
                    })
                );
        },
        /**判断权限 */

        async loadGetPermission() {
            let permissionRequest = [];
            //不包括这个 Coin_CoinManage_Examine的就是 个人
            await this.axios
                .post(this.pub.getApi().GetPermissionByRoleId, {
                    roleID: this.userInfo.roleID
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        for (let i = 0; i < res.data.result.length; i++) {
                            // 代表不是个人数据
                            if (res.data.result[i].permissionsCode == 'Coin_CoinManage_Examine') {
                                this.truePerson = false;
                                break;
                            } else {
                                this.truePerson = true;
                            }
                        }
                        // 非個人 則調用金幣鑽石
                        if (!this.truePerson) {
                            this.loadingDepartmentData = true;
                            this.getDepartmentData('first', 'dateF');
                        }
                    }
                });
            if (this.truePerson) {
                permissionRequest.push(this.axios.get(this.pub.getApi().GetUserCoinDetail)); // 首页个人金币详情
                permissionRequest.push(this.axios.get(this.pub.getApi().GetCurrentUserPropertyDetail)); //个人首页楼盘详情
                let res = await Promise.all(permissionRequest);
                this.userCoinData = res[0].data.result;
                this.currentUserPropertyData = res[1].data.result;
                this.loadingDepartmentData = false;
            }
        },

        chufa(a) {
            //利用nexttick进行更改数据
            this.$nextTick(() => {
                this.loadingDepartmentData = true;
                this.getDepartmentData('second', 'dateF');
            });
        },
        // 嵌套数组扁平化
        flatten2d(arr) {
            return Array.prototype.concat.apply([], arr);
        },
        // 筛选数据调用
        // shaiDep(){
        //     this.showdepData = [];
        //         for (let i = 0; i < this.departids.length; i++) {
        //             for (let it = 0; it < this.depData.length; it++) {
        //                 if (this.departids[i] == this.depData[it].departmentID && this.depData[it].dataType !== 'Total') {
        //                     this.showdepData.push(this.depData[it]);
        //                 }
        //                 if (this.departids[i] == 0) {
        //                     if (this.depData[it].dataType == 'Total') {
        //                         this.showdepData.unshift(this.depData[it]);
        //                     }
        //                 }
        //             }
        //         }
        // },
        // 选择框关闭调用
        disdep($event) {
            if ($event == false) {
                this.loadingDepartmentData = true;
                this.getDepartmentData('second', 'dateF');
            }
        },
        falsedisdep() {
            this.loadingDepartmentData = true;
            this.cancelids = this.departids;
            this.getDepartmentData('second', 'dateF');
            setTimeout(() => {
                this.$refs.multiSelect.blur();
            }, 50);
            if (!this.departids || !this.departids.length) {
                this.departidSel = '';
                return;
            }
            this.departidSel = `已選擇${this.departids.length}項`;
            // console.log('liulei', this.departidSel);
        },
        canceldisdep() {
            this.departids = this.cancelids;
            if (!this.departids || !this.departids.length) {
                this.departidSel = '';
                return;
            }
            this.departidSel = `已選擇${this.departids.length}項`;
        },
        canceldisdep() {
            this.departids = this.cancelids;
            setTimeout(() => {
                this.$refs.multiSelect.blur();
            }, 50);
            if (!this.departids || !this.departids.length) {
                this.departidSel = '';
                return;
            }
            this.departidSel = `已選擇${this.departids.length}項`;
        },
        depChange(data) {
            if (!this.departids || !this.departids.length) {
                this.departidSel = '';
            }
            this.departids = this.flatten2d(this.departids);
            data = this.flatten2d(data);
            if (this.departids) {
                // 全选全部选中
                if (this.departids.includes('100')) {
                    this.quanFlag = true;
                    this.departids = [];
                    for (let z = 0; z < this.treeData.length; z++) {
                        this.departids.push(this.treeData[z].departmentID);
                    }
                    // 点击其余选项 取消全选
                    let xcha = this.departids.length - data.length;
                    if (xcha == 1) {
                        this.quanFlag = false;
                        this.departids = data;
                        for (let k = 0; k < this.departids.length; k++) {
                            if (this.departids[k] == '100') {
                                this.departids.splice(k, 1);
                            }
                        }
                    }
                }
                // 取消全选 全部不选中
                if (data) {
                    if (!this.departids.includes('100') && this.quanFlag == true) {
                        this.quanFlag = false;
                        this.departids = [];
                    }
                }
                this.departidSel = `已選擇${this.departids.length}項`;
            }
        },
        dataPick() {
            this.loadingDepartmentData = true;
            //shijianchuo是整数，否则要parseInt转换
            this.postMonData = this.formatTime(this.mondata)[0];
            this.getDepartmentData('second', 'dateS');
        },
        add0(m) {
            return m < 10 ? '0' + m : m;
        },
        formatTime(a) {
            let time = new Date(a);
            let y = time.getFullYear();
            let m = time.getMonth() + 1;
            let d = time.getDate();
            let h = time.getHours();
            let mm = time.getMinutes();
            let s = time.getSeconds();
            let b = y + '-' + this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(s);
            let c = y + '/' + this.add0(m) + '/' + this.add0(d);
            return [b, c];
        },
        // 获取当月所有组别的所有数据 inCludeTotal: true代表选中了第一个选中allobj
        // 首次进入inCludeTotal为true,其余时候查看是否选中
        async getDepartmentData(isfirst, isDate) {
            this.departidsbymonth = this.departids.concat();
            for (let i = 0; i <= this.departidsbymonth.length; i++) {
                if (isfirst == 'second' && this.departidsbymonth.length == 0) {
                    this.flag = true;
                }
                if (this.departidsbymonth[i]) {
                    if (this.departidsbymonth[i] == 0) {
                        this.flag = true;
                        this.selectedTotal = true;
                        this.departidsbymonth.splice(i, 1);
                    }
                }
            }
            for (let k = 0; k < this.departidsbymonth.length; k++) {
                if (this.departidsbymonth[k] == 100) {
                    this.departidsbymonth.splice(k, 1);
                }
            }
            this.oncoin = {};
            let res = await this.axios.post(this.pub.getApi().GetOrganizationDetailByMonth, {
                departmentID: this.departidsbymonth,
                dateTime: this.postMonData,
                inCludeTotal: this.flag
            });
            this.depData = res.data.result.organizations;
            // this.depData.reverse();
            // 将总行放在第二位
            // 将总览放置在第一位
            let objtotal = {};
            let selfall = {};
            for (let i = 0; i < this.depData.length; i++) {
                if (this.depData[i].dataType == 'Self') {
                    selfall = this.depData[i];
                    this.depData.splice(i, 1);
                    this.depData.unshift(selfall);
                }
            }

            // this.depData.unshift(selfall);
            for (let i = 0; i < this.depData.length; i++) {
                if (this.depData[i].dataType == 'Total') {
                    objtotal = this.depData[i];
                    this.depData.splice(i, 1);
                    this.depData.unshift(objtotal);
                }
            }

            // this.depData.unshift(objtotal);
            if (res.data.result.coinContractEnd == '--/--/--') {
                this.homeinfo.nonetime = '--/--/--';
            }
            if (res.data.result.diamondContractEnd == '--/--/--') {
                this.homeinfo.nonediatime = '--/--/--';
            }
            if (!this.homeinfo.nonetime) {
                this.homeinfo.coinContractEnd = this.formatTime(res.data.result.coinContractEnd)[1];
                this.homeinfo.coinContractStart = this.formatTime(res.data.result.coinContractStart)[1];
            }
            if (!this.homeinfo.nonediatime) {
                this.homeinfo.diamondContractEnd = this.formatTime(res.data.result.diamondContractEnd)[1];
                this.homeinfo.diamondContractStart = this.formatTime(res.data.result.diamondContractStart)[1];
            }
            this.homeinfo.currentMonth = res.data.result.currentMonth;

            this.homeinfo.isUseCoin = res.data.result.isUseCoin;
            this.homeinfo.isUseDiamond = res.data.result.isUseDiamond;
            // 金币或者钻石 金币和钻石 非初次进入 departids为空且includetotal为true  仅展示 总览
            // 金币或钻石  金币和钻石 初次进入 departids为空且includetotal默认true 这时候需要展示全部
            if (isfirst == 'first') {
                // 两种货币
                if (this.homeinfo.isUseCoin && this.homeinfo.isUseDiamond) {
                    // 仅有一种组别时仅显示总览
                    if (this.depData.length == 2) {
                        if (this.depData[0].departmentID == this.depData[1].departmentID) {
                            this.depData.pop();
                            this.shouzubie = false;
                        }
                    }
                    this.showdepData = this.depData;
                }
                // 一种货币
                if ((!this.homeinfo.isUseCoin && this.homeinfo.isUseDiamond) || (this.homeinfo.isUseCoin && !this.homeinfo.isUseDiamond)) {
                    for (let z = 0; z < this.depData.length; z++) {
                        if (this.depData[z].dataType == 'Total') {
                            this.oncoin = this.depData[z];
                            this.depData.splice(z, 1);
                        }
                    }
                    // 仅有一种组别时仅显示总览
                    if (this.depData.length == 1) {
                        if (this.depData[0].departmentID == this.oncoin.departmentID) {
                            this.showdepData = [];
                            this.shouzubie = false;
                        } else {
                            this.showdepData = this.depData;
                        }
                    } else {
                        this.showdepData = this.depData;
                    }
                }
            }
            if (isfirst == 'second') {
                // 两种货币
                if (this.homeinfo.isUseCoin && this.homeinfo.isUseDiamond) {
                    // 仅有一种组别时仅显示总览
                    if (isDate == 'dateS') {
                        if (!this.shouzubie) {
                            // this.showdepData = this.depData[0];
                            this.showdepData = [];
                            this.showdepData.push(this.depData[0]);
                            this.loadingDepartmentData = false;
                            return;
                        }
                    }
                    if (this.departidsbymonth.length == 0 && this.flag == true && this.selectedTotal == true) {
                        this.showdepData = [];
                        for (let z = 0; z < this.depData.length; z++) {
                            if (this.depData[z].dataType == 'Total') {
                                this.showdepData.push(this.depData[z]);
                                this.depData.splice(z, 1);
                            }
                        }
                    } else {
                        this.showdepData = this.depData;
                    }
                }
                //一种货币
                if ((!this.homeinfo.isUseCoin && this.homeinfo.isUseDiamond) || (this.homeinfo.isUseCoin && !this.homeinfo.isUseDiamond)) {
                    // 仅有一种组别时 显示总览
                    if (isDate == 'dateS') {
                        if (!this.shouzubie) {
                            for (let z = 0; z < this.depData.length; z++) {
                                if (this.depData[z].dataType == 'Total') {
                                    this.oncoin = this.depData[z];
                                }
                            }
                            this.loadingDepartmentData = false;
                            return;
                        }
                    }
                    for (let z = 0; z < this.depData.length; z++) {
                        if (this.depData[z].dataType == 'Total') {
                            this.oncoin = this.depData[z];
                            this.depData.splice(z, 1);
                        }
                    }
                    if (this.departidsbymonth.length == 0 && this.flag == true && this.selectedTotal == true) {
                        this.showdepData = [];
                    } else {
                        this.showdepData = this.depData;
                    }
                }
            }
            this.flag = false;
            this.selectedTotal = false;
            this.loadingDepartmentData = false;
        },

        // 获取组织树结构
        async getDepartmentsTree() {
            this.treeLoading = true;
            let res = await this.axios.get(this.pub.getApi().GetDepartmentsTreeByParentID, {
                params: {
                    departmentID: this.userInfo.departmentID
                }
            });
            this.treeLoading = false;
            let allobj = {
                departmentName: '總行數據合共',
                departmentID: '0'
            };
            let quanxuan = {
                departmentName: '全選',
                departmentID: '100'
            };
            let { code, message, result } = res.data;
            if (!res.data.result.childNode) {
                this.shouzubie = false;
            }
            if (code === 0) {
                this.treeData = [result];
                if (this.treeData[0].childNode) {
                    this.treeData[0].childNode.forEach(item => {
                        this.treeData.push(item);
                    });
                    this.treeData.unshift(allobj);
                    this.treeData.unshift(quanxuan);
                } else {
                    this.treeData.unshift(allobj);
                    this.treeData.unshift(quanxuan);
                }
                this.departmentName = result.departmentName;
                this.remainderPropertyCoin = result.remainderPropertyCoin;
                this.remainderDiamond = result.remainderDiamond;
            }
        },
        //默认选中为当前月份
        getdatatime() {
            this.mondata = new Date();
        },
        // 切换账户
        changeDepartment() {
            this.$router.push({ name: this.pub.routeNameLists.SelectRole });
        },
        /**页面引导 */
        guidePage(isFirst) {
            let steps = [];
            if (this.userInfo.roleID == 3 || this.userInfo.roleID == 4) {
                steps = [
                    {
                        element: '.guide-message',
                        stageBackground: '#eee',
                        doneBtnText: '下一步',
                        closeBtnText: '關閉',
                        popover: {
                            className: isFirst ? 'first-guidance' : 'personal',
                            title: '消息通知'
                        },
                        onNext: () => {
                            this.$router.push({
                                name: this.pub.routeNameLists.PropertyIndex,
                                params: {
                                    guide: 1,
                                    initiativeGuide: this.$route.params.initiativeGuide
                                }
                            });
                        }
                    }
                ];
            } else {
                steps = [
                    {
                        element: '#System',
                        closeBtnText: '關閉',
                        doneBtnText: '下一步',
                        popover: {
                            className: isFirst ? 'first-guidance' : '',
                            title: '管理員工賬戶及業務架構, <br>修改公司賬戶資料'
                        }
                    },
                    {
                        element: '.guide-message',
                        stageBackground: '#eee',
                        doneBtnText: '下一步',
                        closeBtnText: '關閉',
                        popover: {
                            className: isFirst ? 'first-guidance' : 'left-lpgl',
                            title: '消息通知'
                        },
                        onNext: () => {
                            this.$router.push({
                                name: this.pub.routeNameLists.SystemOrg,
                                params: {
                                    guide: 1,
                                    initiativeGuide: this.$route.params.initiativeGuide
                                }
                            });
                        }
                    }
                ];
            }
            setTimeout(() => {
                this.pub.guide(this.Driver, steps);
            }, 500);
        },
        // 利嘉阁放盘有效期提示
        showTips() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    // 1 中原，2 利嘉阁 3 其他公司
                    if (res.data.result.companyCategory === 2) {
                        let loginDate = JSON.parse(localStorage.getItem('login-date')) || [];
                        let loginUser = loginDate.find(item => {
                            return item.email === this.userInfo.email;
                        });
                        if (!loginUser || !this.isToday(+loginUser.timestamp)) {
                            if (!loginUser) {
                                loginDate.push({ timestamp: +new Date(), email: this.userInfo.email });
                            } else if (!this.isToday(+loginUser.timestamp)) {
                                loginUser.timestamp = +new Date();
                            }
                            localStorage.setItem('login-date', JSON.stringify(loginDate));
                            this.$alert('按利嘉閣公司規定，由8月1日起，新刊登樓盤有效期為30天', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    // this.$message({
                                    //   type: 'info',
                                    //   message: `action: ${ action }`
                                    // });
                                }
                            });
                        }
                    }
                }
            });
        },
        isToday(timestamp) {
            let last = new Date(timestamp);
            let current = new Date();
            return last.setHours(0, 0, 0, 0) == current.setHours(0, 0, 0, 0);
        }
    }
};
</script>

<style lang="less" scoped>
// 日期限制 需要在全局写才行
// .datedie.el-date-picker {
//     .el-month-table {
//         td.today {
//             .cell {
//                 color: rgb(96 98 102) !important;
//                 font-weight: 400 !important;
//             }
//         }
//     }
// }
// 嵌套为option
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    content: '';
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected .check {
    background-color: #409eff;
    border-color: #409eff;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected .check:after {
    transform: rotate(45deg) scaleY(1);
}
.el-select-dropdown.is-multiple .el-select-dropdown__item .check::after {
    box-sizing: content-box;
    content: '';
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 3px;
    transition: transform 0.15s ease-in 0.05s;
    transform-origin: center;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item .check {
    display: inline-block;
    position: relative;
    top: 2px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    background-color: #fff;
    z-index: 1;
    transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46), background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
.el-select /deep/.el-tag {
    max-width: 140px !important;
}
.el-select /deep/.el-select__tags {
    flex-wrap: nowrap;
}

// 嵌套为panel
.wuborder.el-cascader-panel.is-bordered {
    border: none;
}

.container {
    /deep/.selx {
        left: 0 !important;
        height: 173px;
        text-align: left;
        // 级联选择器点击就选中
        .el-cascader-panel .el-checkbox {
            width: 100%;
            height: 100%;
            z-index: 10;
            position: absolute;
            top: -2px;
            right: -9px;
        }
        .oneone {
            .wuborder.el-cascader-panel.is-bordered {
                .el-scrollbar.el-cascader-menu {
                    .el-cascader-menu__wrap.el-scrollbar__wrap {
                        height: 158px;
                        overflow-y: scroll;
                        margin-bottom: 0px;
                        margin-right: 0px !important;
                        max-width: 397px;
                        // .el-scrollbar__view.el-cascader-menu__list{
                        //     .el-cascader-node{
                        //         .el-cascader-node__label{
                        //             padding-right: 0 !important;
                        //         }
                        //     }
                        // }
                    }
                    .el-scrollbar__bar.is-vertical {
                        visibility: hidden;
                    }
                    .el-scrollbar__bar.is-horizontal {
                        visibility: hidden;
                    }
                }
            }
        }
        /* 这个样式针对IE有用，不考虑IE的可以不用管*/
        .el-cascader-panel .el-cascader-node__postfix {
            top: 10px;
        }

        .el-scrollbar .el-scrollbar__bar .is-vertical {
            visibility: hidden;
        }

        // 在你的重置样式表内加入这段代码即可
        .el-select-dropdown.is-multiple .el-select-dropdown__item {
            padding-right: 0;
        }
        .el-select-dropdown__item {
            padding: 0;
            padding-left: 7px;
        }
        // .oneone {
        //     // overflow-y可以控制其是否显示 当超过4个时候可以使用overflow
        //     height: 137px;
        //     overflow-y: scroll;
        //     background-color: #ffffff;
        // }
        // .twotwo{
        //     overflow-y: scroll;
        // }
        .btnSel {
            padding-left: 30px;
            padding-top: 4px;
            background-color: #ffffff;
            border: 1px solid #e8eaef;
            height: 40px;
        }
    }
    .font-tit {
        font-size: 18px;
        color: #666666;
    }

    // transform: translate(0, 0);
    /deep/ .new-version-popup {
        .new-version-popup-notice {
            text-align: left;
            line-height: 26px;
            font-size: 15px;
            color: #333;
            padding: 0 32px;
        }
        .new-version-popup-btn {
            text-align: right;
            padding: 38px 36px 0;
            .el-button {
                width: 98px;
            }
        }
    }
    .oncoin-div {
        background-color: #f1f1f1;
        width: 100%;
        height: 40px;
    }
    .home_head {
        position: relative;
        top: -8px;
        left: 5px;
        background-color: #f3f3f5;
        width: 100%;
        z-index: 1;
        padding-top: 24px;
        .ch-form-img {
            width: 50px;
            height: 50px;
            border-radius: 50px;
            overflow: hidden;
            margin-left: 5px;
            margin-right: 5px;
            .ch-image {
                display: inline-block;
                width: 100%;
                height: 100%;
                background-size: 100% 100%;
                background-color: #eee;
            }
        }
        .ch-form-tit {
            position: absolute;
            left: 70px;
            top: 37px;
        }
        .home_date {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            background-color: #495c81;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            text-align: center;
            height: 37px;
            line-height: 20px;
            margin-top: 29px;
            padding: 8px 0 13px 23px;
            .home_flex {
                .dateicon {
                    position: absolute;
                    right: 41px;
                    top: 123px;
                    color: rgb(204 198 204);
                    cursor: pointer;
                }
                .aside-container {
                    box-sizing: border-box;
                    display: inline-block;
                    .search-box {
                        .fuclodateicon {
                            width: 106px;
                            height: 30px;
                            position: absolute;
                            right: 283px;
                            top: 115px;
                            opacity: 0.5;
                            background-color: #c1c1c1;
                            border-radius: 8px;
                        }
                        .clodateicon {
                            position: absolute;
                            right: 292px;
                            top: 124px;
                            color: rgb(204 198 204);
                            cursor: pointer;
                        }
                        .form-input {
                            width: 200px;
                            border-radius: 25px;
                        }
                    }
                }
                .data_pick {
                    margin: 0 30px 0 20px;
                    width: 150px;
                    border-radius: 25px;
                }
            }
        }
    }

    .home_container {
        margin: -26px 5px 0 5px;
        width: 100%;
        .el-row {
            margin-bottom: 30px;
            background-color: #ffffff;
            border-radius: 25px;
            padding-bottom: 20px;
        }
        // .home_container :first-child{
        // border-top-left-radius:0;
        // border-top-right-radius:0;
        // border-bottom-left-radius:25px;
        // border-bottom-right-radius:25px;
        // }
        .totalclass {
            background-color: rgba(80, 181, 255, 0.15);
        }
    }
    .home-tit {
        text-align: left;
        font-size: 18px;
        font-weight: 700;
        margin: 20px 0 20px 25px;
    }
    .hometwo {
        background-color: #fff;
        padding: 14px 27px 19px 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        border-radius: 17px;
        border: 1px solid #dbdbdb;
        .zuocontain {
            width: 14%;
            display: inline-block;
            padding-left: 10px;
        }
        .youcontain {
            width: 80%;
            margin-left: 20px;
            text-align: left;
            .t-dyu-tongji {
                border-bottom: 1px solid #e2e2ea;
                margin-top: 20px;
            }
            .t-dyu-flextongji {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .t-dyu-flextongji-t {
                margin-bottom: 15px;
                margin-top: 15px;
            }
        }
    }

    .t-shou-yi {
        padding: 12px 18px 17px 10px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        background-color: #fff;
        border-radius: 17px;
        border: 1px solid #dbdbdb;
        .t-shou-tu {
            width: 14%;
            .baoyuan {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                border: 2px solid gray;
            }
        }
        .shouyuan {
            max-width: 30px;
            max-height: 30px;
            font-weight: 700;
            color: #666666;
            font-size: 18px;
        }
        .t-kan-yi {
            text-align: left;
            width: 39%;
        }
        .t-sanpan {
            margin-left: 10px;
            width: 37%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .t-xing {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                span {
                    font-size: 18px;
                    color: #666666;
                }
            }
        }
    }

    .t-lishishou-yi {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        padding: 12px 18px 17px 10px;
        background-color: #fff;
        border-radius: 17px;
        border: 1px solid #dbdbdb;
        .t-shou-tu {
            width: 14%;
            .baoyuan {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                border: 2px solid gray;
            }
        }
        .shouyuan {
            max-width: 30px;
            max-height: 30px;
            font-weight: 700;
            color: #666666;
            font-size: 18px;
        }
        .t-kan-yi {
            text-align: left;
            width: 76%;
            .t-sanpan {
                margin-top: 30px;
                .t-xing {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-bottom: 10px;
                    span {
                        font-size: 18px;
                        color: #666666;
                    }
                }
            }
        }
    }

    .t-oncoinshou-yi {
        padding: 12px 18px 17px 10px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        background-color: #fff;
        border-radius: 17px;
        border: 1px solid #dbdbdb;
        .t-shou-tu {
            width: 14%;
            .baoyuan {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                border: 2px solid gray;
            }
        }
        .shouyuan {
            max-width: 30px;
            max-height: 30px;
            font-weight: 700;
            color: #666666;
            font-size: 18px;
        }
        .t-kan-yi {
            text-align: left;
            width: 50%;
        }
        .t-oncoinsanpan {
            text-align: left;
        }
    }
    .t-shou-er {
        margin-top: 54px;
    }
    // 个人
    .geren {
        border: 1px solid #dbdbdb;
        border-radius: 25px;
        .geren-zuoa {
            border-bottom: 1px solid #dbdbdb;
        }
        .gerenzuoa {
            // height:120px;
            border-bottom: 1px solid #dbdbdb;
        }
        .geren-zuo {
            padding: 20px 0 20px 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            text-align: left;
            .zuocontain {
                width: 8%;
            }
            .geren-zuoin {
                width: 23%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                .geren-zuoin-hui {
                    font-size: 20px;
                    color: #666666;
                    margin-top: 17px;
                }
                .geren-zuoin-xia {
                    margin-top: 20px;
                    color: #44444f;
                }
            }
        }
    }
    .gerenyoua {
        height: 120px;
    }
    .gerenbox{
        border-radius: 25px;
        border: 1px solid #dbdbdb;
        padding: 0 16px 95px 30px;
        .geren-you-tit{
            height: 50px;
            line-height: 50px;
            text-align: left;
            font-size: 14px;
            color: #000000;
        }
    }
    .geren-you {
        // border: 1px solid #dbdbdb;
        // border-radius: 25px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        // padding: 42px 16px 72px 30px;
        .geren-you-pan {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 60%;
            
            .geren-shouzu {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                border-bottom: 1px solid #dbdbdb;
                span {
                    margin-bottom: 15px;
                    font-size: 18px;
                    color: #666666;
                }
            }
            .geren-sipan {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                color: #666666;
                span {
                    margin-top: 20px;
                    cursor: pointer;
                }
            }
        }
        .geren-you-panzhong {
            margin-top: 35px;
            color: #666666;
            margin-left: 30px;
            div {
                margin-top: 20px;
            }
            .panzhongdiv{
                margin-top:50px;
                text-align:left;
            }
        }
    }
}
</style>

